import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { DurationsRuleBody } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/DurationsRuleBody';
import { DurationsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/DurationsRuleHeader';

export type DurationsRuleProps = Omit<AccordionProps, 'header' | 'body'>;

export function DurationsRule({ ...props }: DurationsRuleProps): JSX.Element {
  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <DurationsRuleHeader isActive={isActive} />
      )}
      body={(isActive): JSX.Element => (
        <DurationsRuleBody isActive={isActive} />
      )}
    />
  );
}
